import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets window scroll to (0,0) on every pathname change.
 * Anchored hashes (e.g. /regions#cascais) are honoured and left untouched.
 * Must be mounted inside <BrowserRouter>.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let the browser handle anchor scrolling
    // Use the legacy two-arg form which is guaranteed instant across all browsers.
    window.scrollTo(0, 0);
    // Belt-and-braces for pages that have <html> or <body> as the scroll root.
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
